import React, { useState, useEffect } from 'react';
import { FiPlus, FiEdit2, FiTrash2, FiSearch } from 'react-icons/fi';
import { api } from '../api';
import { useMe } from '../App';
import { findPerm } from '../perm';

export default function WarrantyProducts() {
  const me = useMe();
  const perm = findPerm(me.modules, 'warranty_products');
  const [data, setData] = useState(null);
  const [brand, setBrand] = useState('');
  const [sub, setSub] = useState('');
  const [search, setSearch] = useState('');
  const [modal, setModal] = useState(null);
  const [toast, setToast] = useState('');

  async function load() {
    const qs = new URLSearchParams();
    if (brand) qs.set('brand', brand);
    if (sub) qs.set('sub_brand', sub);
    try { setData(await api('/warranty-products' + (qs.toString() ? '?' + qs : ''))); } catch (e) { setToast(e.message); }
  }
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [brand, sub]);
  function flash(m) { setToast(m); setTimeout(() => setToast(''), 2600); }

  async function remove(p) {
    if (!window.confirm(`Delete "${p.colour_code}"?`)) return;
    try { await api('/warranty-products/' + p.id, { method: 'DELETE' }); flash('Deleted'); load(); }
    catch (e) { flash(e.message); }
  }

  if (!data) return <div className="empty">{toast || 'Loading…'}</div>;

  const brands = [...new Set(data.meta.map((m) => m.brand))];
  const subBrands = [...new Set(data.meta.filter((m) => !brand || m.brand === brand).map((m) => m.sub_brand).filter(Boolean))];
  const filtered = data.products.filter((p) => {
    if (!search) return true;
    const s = search.toLowerCase();
    return (p.colour_code || '').toLowerCase().includes(s) || (p.description || '').toLowerCase().includes(s) || (p.sub_brand || '').toLowerCase().includes(s);
  });

  return (
    <div>
      <div className="mod-head">
        <div className="titles">
          <div className="page-eyebrow">Warranty</div>
          <h1>Products</h1>
          <div className="count">{data.products.length} products · used by the public warranty form</div>
        </div>
        {perm.can_create && <button className="btn btn-dark" onClick={() => setModal({ mode: 'add', product: { brand: brand || 'SmartBoard' } })}><FiPlus /> Add product</button>}
      </div>

      <div className="filter-bar">
        <div style={{ position: 'relative', flex: 1, minWidth: 220 }}>
          <FiSearch style={{ position: 'absolute', left: 12, top: 11, color: 'var(--muted)' }} />
          <input value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Search code, description…"
            style={{ width: '100%', padding: '9px 12px 9px 34px', border: '1px solid var(--line)', borderRadius: 9, fontSize: 14 }} />
        </div>
        <select className="status-select" value={brand} onChange={(e) => { setBrand(e.target.value); setSub(''); }}>
          <option value="">All brands</option>
          {brands.map((b) => <option key={b} value={b}>{b}</option>)}
        </select>
        <select className="status-select" value={sub} onChange={(e) => setSub(e.target.value)}>
          <option value="">All sub-brands</option>
          {subBrands.map((s) => <option key={s} value={s}>{s}</option>)}
        </select>
      </div>

      <div className="table-card">
        {filtered.length === 0 ? <div className="empty"><h3>No products</h3><p>Add products for the warranty form to offer.</p></div> :
          <table className="data">
            <thead><tr><th>Colour code</th><th>Finish</th><th>Sub-brand</th><th>Brand</th><th>Description</th>
              {(perm.can_edit || perm.can_delete) && <th style={{ textAlign: 'right' }}>Actions</th>}</tr></thead>
            <tbody>
              {filtered.slice(0, 400).map((p) => (
                <tr key={p.id} style={{ opacity: p.is_active ? 1 : 0.5 }}>
                  <td style={{ fontWeight: 600 }}>{p.colour_code}</td>
                  <td style={{ color: 'var(--muted)' }}>{p.finish || '—'}</td>
                  <td style={{ color: 'var(--muted)' }}>{p.sub_brand || '—'}</td>
                  <td style={{ color: 'var(--muted)' }}>{p.brand}</td>
                  <td style={{ color: 'var(--muted)', fontSize: 13, maxWidth: 320, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{p.description || '—'}</td>
                  {(perm.can_edit || perm.can_delete) && (
                    <td><div className="row-actions">
                      {perm.can_edit && <button className="btn btn-sm" onClick={() => setModal({ mode: 'edit', product: p })}><FiEdit2 /></button>}
                      {perm.can_delete && <button className="btn btn-sm btn-danger" onClick={() => remove(p)}><FiTrash2 /></button>}
                    </div></td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>}
        {filtered.length > 400 && <p className="page-desc" style={{ padding: 14, fontSize: 13 }}>Showing first 400. Use search or filters to narrow.</p>}
      </div>

      {modal && <ProductModal {...modal} brands={brands} onClose={() => setModal(null)} onSaved={(m) => { setModal(null); flash(m); load(); }} />}
      {toast && <div className="toast">{toast}</div>}
    </div>
  );
}

function ProductModal({ mode, product, brands, onClose, onSaved }) {
  const [f, setF] = useState({
    brand: product.brand || 'SmartBoard', sub_brand: product.sub_brand || '',
    colour_code: product.colour_code || '', finish: product.finish || '', description: product.description || '',
  });
  const [error, setError] = useState(''); const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  async function save() {
    setError(''); setBusy(true);
    try {
      if (mode === 'add') { await api('/warranty-products', { method: 'POST', body: f }); onSaved('Product added'); }
      else { await api('/warranty-products/' + product.id, { method: 'PUT', body: f }); onSaved('Product updated'); }
    } catch (e) { setError(e.message); setBusy(false); }
  }

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal" style={{ maxWidth: 500 }} onClick={(e) => e.stopPropagation()}>
        <h2>{mode === 'add' ? 'Add product' : 'Edit product'}</h2>
        <div className="grid2">
          <div className="field"><label>Brand</label>
            <input value={f.brand} onChange={set('brand')} list="brandlist" placeholder="SmartBoard" />
            <datalist id="brandlist">{['SmartBoard','Durawall','Homewood',...brands].filter((v,i,a)=>a.indexOf(v)===i).map((b)=><option key={b} value={b} />)}</datalist>
          </div>
          <div className="field"><label>Sub-brand</label><input value={f.sub_brand} onChange={set('sub_brand')} placeholder="e.g. Coreline" /></div>
        </div>
        <div className="grid2">
          <div className="field"><label>Colour code</label><input value={f.colour_code} autoFocus onChange={set('colour_code')} placeholder="e.g. SB2001" /></div>
          <div className="field"><label>Finish</label><input value={f.finish} onChange={set('finish')} placeholder="e.g. Semi Glossy" /></div>
        </div>
        <div className="field"><label>Description / full product name</label>
          <input value={f.description} onChange={set('description')} placeholder="Full descriptive name" /></div>
        {error && <div className="inline-error">{error}</div>}
        <div className="modal-actions">
          <button className="btn" onClick={onClose} disabled={busy}>Cancel</button>
          <button className="btn btn-dark" onClick={save} disabled={busy || !f.colour_code.trim()}>{busy ? 'Saving…' : 'Save'}</button>
        </div>
      </div>
    </div>
  );
}
